import styled from 'styled-components'
import { Link as LinkR } from 'react-router-dom'
import { Link } from 'react-router-dom'

export const Container = styled.nav`
flex: 1,
display: flex;
justify-content: center;
align-items: center;
flex-direction: row;
@media screen and (max-width: 960px) {
  transition: 0.8s all ease;
}
`;

export const ContainerA = styled.nav`
flex: 1,
display: flex;
justify-content: center;
align-items: center;
@media screen and (max-width: 960px) {
  transition: 0.8s all ease;
}
`;

export const ContainerB = styled.nav`
flex: 4,
display: flex;
justify-content: center;
align-items: center;

@media screen and (max-width: 960px) {
  transition: 0.8s all ease;
}
`;

export const Nav = styled.nav`
background: red;
height: 80px;
display: flex;
justify-content: center;
align-items: center;
font-size: 1rem;
position: sticky;
top: 0;

@media screen and (max-width: 960px) {
  transition: 0.8s all ease;
}
`;



export const Logo = styled.img`
height: 25px;
width: 25px;
`;

export const Logo2 = styled.img`
height: 30px;
width: 200px;
`;

export const NavbarContainer = styled.div`
display: flex;
justify-content: space-between;
height: 80px;
z-index: 1;
width: 100%;
padding: 0 24px;
max-width: 1250px;
`

export const NavLogo = styled(LinkR)`
color: #fff;
justify-self: flex-start;
cursor: pointer;
font-size: 1.5rem;
display: flex;
align-items: center;
font-weight: bold;
text-decoration: none;
`;

export const MobileIcon = styled.div`
display: none;

@media screen and (max-width: 768px) {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 60%);
    font-size: 1.8rem;
    cursor: pointer;
    color: #fff;
  }
`;

export const NavMenu = styled.ul`
    display: flex;
    align-items: center;
    list-style: none;
    text-align: center;
    margin-right: -22;

    @media screen and (max-width: 768px) {
        display: none;
      }
`;

export const NavItem = styled.li`
    height: 80px;
`;

export const NavLinks = styled(Link)`
    color: #fff;
    display: flex;
    align-items: center;
    text-decoration: none;
    height: 100%;
    
  }
`;

export const NavLinkR = styled(LinkR)`
    color: #fff;
    display: flex;
    align-items: center;
    text-decoration: none;
    padding: 0 1rem;
    height: 100%;
    cursor: pointer;

    &.active {
    border-bottom: 3px solid #3279CF;
    
    
  }
`;


export const NavLinksSwap = styled(LinkR)`
    color: #fff;
    display: flex;
    align-items: center;
    text-decoration: none;
    padding: 0 1rem;
    height: 100%;
    cursor: pointer;

    &.active {
    border-bottom: 3px solid #3279CF;
    color: #fff
    
  }
`;

export const NavBtn = styled.nav`
display: flex;
align-items: center;

@media screen and (max-width: 768px) {
  display: none;
`;

export const NavBtnWsp = styled.nav`
display: flex;
flex: 0.8;
align-items: center;


@media screen and (max-width: 768px) {
  display: none;
  color: #fff
`;


export const NavBtnLinkWsp = styled(LinkR)`

border-radius: 50px;
background: linear-gradient(
  108deg,
  rgba(13, 75, 150, 1) 0%,
  rgba(73, 77, 83, 1) 100%
);
white-space: nowrap;
padding: 10px 12px;
color: #FFF;
fontSize: 16px;
outline: none;
border: 1px solid white;
cursor: pointer;
transition: all 0.2s ease-in-out;
text-decoration: none;

&:hover {
  transition: all 0.2s ease-in-out;
  background: #fff;
  color: #010606;
}
`;


export const NavBtnLinkWallet = styled(LinkR)`

border-radius: 50px;
background: #494949;
white-space: nowrap;
padding: 10px 12px;
color: #FFF;
fontSize: 16px;
outline: none;
border: 1px solid #3279CF;
cursor: pointer;
transition: all 0.2s ease-in-out;
text-decoration: none;

&:hover {
  transition: all 0.2s ease-in-out;
  background: #242524;
  color: #3279CF;
}
`;

export const SocialIconLinks = styled.div`


width: 40px;
height: 40px,
max-width: 40px;
max-height: 40px,

align-items: center;
justify-content: center;

border-radius: 50px;
color: #010606;
fontSize: 16px;
outline: none;
border: none;
cursor: pointer;
transition: all 0.2s ease-in-out;
text-decoration: none;

&:hover {
  transition: all 0.2s ease-in-out;
  background: #0C6D9B;
  color: #010606;
  padding: 8px 15px;
  max-width: 120px;
  align-items: flex-start;
  color: #fff;
font-size: 20px;

}


`;

export const NavBtnLink = styled(LinkR)`
border: 1px solid white;
border-radius: 50px;
background:linear-gradient(
  108deg,
  rgba(13, 75, 150, 1) 0%,
  rgba(73, 77, 83, 1) 100%
);
white-space: nowrap;
padding: 10px 22px;
color: #FFF;
fontSize: 16px;
outline: none;
cursor: pointer;
transition: all 0.2s ease-in-out;
text-decoration: none;

&:hover {
  transition: all 0.2s ease-in-out;
  background: #fff;
  color: #010606;
}
`;